module.exports = __webpack_public_path__ + "cania-programas.f64d5c12c8d09ae89c3f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconos/fonts/cania-programas.woff?s2o10a
// module id = 1470
// module chunks = 2